/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * User who last updated the entity
 */
export type MeasurementUnitUpdatedBy = { [key: string]: unknown };
